import { call, put, select, takeEvery } from "redux-saga/effects";
import { FINALIZE_PROCECCESSING_PAYMENT_ACTION, INIT_PROCESSING_PAYMENT_ACTION } from "./actionTypes";
import { PayloadAction } from "@reduxjs/toolkit";
import { deleteProcessingPayment, initNewProcessingPayment } from "../../service/processingPayments";
import { ProductWithPrice } from "../../types/stripe";
import { finalizeProcessingPaymentError, finalizeProcessingPaymentSuccess, initProcessingPaymentError, initProcessingPaymentSuccess } from "./slice";
import { StoreState } from "../reducer-main";
import { Membership, UserProfile } from "../../types/profile";
import { retrieveUserMembershipObj } from "../../service/profile";
import { updateMembershipData } from "../profile/slice";

function* initProcessingPayment({
  payload: { uid, subscription/* , product  */}
}: PayloadAction<{uid: string; subscription: any/* ; product: ProductWithPrice */}>): any {
  try {
    yield call(initNewProcessingPayment, uid, subscription);
    console.log('CREATO PROCESSING PAYMENT DOC');
    yield put(initProcessingPaymentSuccess());
  } catch (error) { 
    console.log('PROCESSING PAYMENTS SAGA ERROR [initProcessingPayment]', error);
    yield put(initProcessingPaymentError('000'));
  }
}

function* finalizeProcessingPayment({
  payload: _
}: PayloadAction<undefined>): any {
  try {
    const userProfile: UserProfile = yield select((state: StoreState) => state.profile.userProfile);
    const newMembershipObj: Membership = yield call(retrieveUserMembershipObj, userProfile.uid);
    yield call(deleteProcessingPayment, userProfile.uid);
    yield put(updateMembershipData(newMembershipObj));
    yield put(finalizeProcessingPaymentSuccess());
  } catch (error) {
    console.log('ERRORE FINALIZZAZIONE DEL PAGAMENTO', error);
    yield put(finalizeProcessingPaymentError('000'));
  }
}

export default function* processingPaymentsSaga() {
  yield takeEvery(INIT_PROCESSING_PAYMENT_ACTION, initProcessingPayment);
  yield takeEvery(FINALIZE_PROCECCESSING_PAYMENT_ACTION, finalizeProcessingPayment);
}